import React, { Component } from 'react'
import { connect } from 'react-redux';

import {
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Button,
  MenuItem,
} from '@material-ui/core';
import Page from '../../common-components/Page';
import * as strings from '../../helpers/strings';
import { getUserId,getFastDataStationId } from '../../helpers/common';

import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as downloadDataReducers from '../reducer/DownloadDataSelectReducers';
import * as downloadDataActionMgr from '../action-mgr';

class DownloadDataSelect extends Component {
  constructor() {
    super();
    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleSelectYear = this.handleSelectYear.bind(this);
    this.handleSelectMonth = this.handleSelectMonth.bind(this);
    this.handleDownloadDataSubmit =  this.handleDownloadDataSubmit.bind(this);
    this.handleReset =  this.handleReset.bind(this);
    this.state = {
      selectedStationName: '',
      selectedYear: '',
      selectedMonth: '',
      isResetButtonDisabled: true,
    };
  }

  componentDidMount() {
    const { stations, checkDownloadDataObject, currentStationName, setSelectDownloadDataStation, selectYear, selectMonth} = this.props;
    selectYear(''); 
    selectMonth('');
    
    if (stations.length > 0) {
      const selectedStation = stations.find(station => station.id === getFastDataStationId());
      const stationName = currentStationName || (selectedStation ? selectedStation.name : stations[stations.length - 1].name);
  
      setSelectDownloadDataStation(stationName);  
      
      const requestData = {
        userId: getUserId(),
        stationName,
      };
      if (checkDownloadDataObject !== "" ){
        checkDownloadDataObject(requestData);
      }
    }

  }

  // Handle the station change
  handleStationChange = (event) => {
    const { setSelectDownloadDataStation, setCurrentDownloadDataStation, checkDownloadDataObject, selectYear, selectMonth, clearSelectedFiles  } = this.props;
    const selectedStationName = event.target.value;
    setSelectDownloadDataStation(selectedStationName);
    setCurrentDownloadDataStation(selectedStationName);
    // Call the checkDownloadDataObject API to fetch available years
    const requestData = {
      userId: getUserId(),
      stationName: selectedStationName,
    };
    if (checkDownloadDataObject !== "" ){
      checkDownloadDataObject(requestData);
    }

    selectYear(''); 
    selectMonth('');
    clearSelectedFiles();
  };

  handleSelectMonth = event => {
    const { selectMonth, clearSelectedFiles } = this.props;
    const month = event.target.value;
    selectMonth(month);
    this.setState({ 
      selectedMonth: month,
      isResetButtonDisabled: false
    });
    clearSelectedFiles();
  }
  
  handleSelectYear = event => {
    const { selectedStationName, selectYear, checkDownloadDataObject, clearSelectedFiles } = this.props;
    const year = parseInt(event.target.value, 0);
    
    this.setState({
      selectedYear: year,
      isResetButtonDisabled: false
    });
    selectYear(year);

    // Call the checkDownloadDataObject API to fetch available years
    const requestData = {
      userId: getUserId(),
      stationName: selectedStationName,
      year: year
    };
    if (checkDownloadDataObject !== "" ){
      checkDownloadDataObject(requestData);
    }
    clearSelectedFiles();
    this.props.selectMonth('');
  }

  handleDownloadDataSubmit = () => {
    const { selectedStationName, selectedYear, selectedMonth, listDownloadDataObject } = this.props;
  
    // Create the request data object with "userId" and "stationName"
    const requestdata = {
      "userId": getUserId(),
      "stationName": selectedStationName,
      "year": selectedYear,
    };
    // Add "month" to the request data only if selectedMonth is not empty
    if (selectedMonth !== '') {
      requestdata["month"] = selectedMonth;
    }
    listDownloadDataObject(requestdata);
  };

  handleReset = () => {
    // Reset the selected values to their initial states
    this.setState({
      selectedStationName: '',
      selectedYear: '',
      selectedMonth: '',
      isResetButtonDisabled: true,
    });

    this.props.selectMonth('');
    this.props.selectYear('');
    this.props.clearSelectedFiles();
  };

  render() {

    const {
      stations,
      selectedStationName, 
      currentStationName,
      downloadDataCheckObject,
      selectedYear, 
      selectedMonth,
    } = this.props;

    const currentDownloadDataStationName = currentStationName || selectedStationName;

    // Function to convert "YYYY-MM" format to month name
    const getMonthName = (yearMonth) => {
      const [year, month] = yearMonth.split('-');
      const date = new Date(`${year}-${month}-01`);
      const monthName = date.toLocaleString('default', { month: 'long' });
      return `${monthName}`;
    };
    const sortStations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1)
    return (
      <Paper>
        <Page title={strings.lblDownload}>
          <Grid container spacing={16}>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectStation}>
                  {strings.lblStation}
                </InputLabel>
                <Select
                  value={currentDownloadDataStationName}
                  onChange={this.handleStationChange}
                  input={
                    <OutlinedInput
                      labelWidth={60}
                      name={strings.lblStations}
                      id={strings.idSelectStation}
                    />
                  }
                >
                 {sortStations.map(station => (
                    <MenuItem key={station.id} value={station.name}>
                      {station.name} - {station.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectYear}>{strings.lblYear}</InputLabel>
                <Select
                  value={selectedYear}
                  onChange={this.handleSelectYear}
                  input={
                    <OutlinedInput
                      labelWidth={50}
                      name={strings.lblYear}
                      id={strings.idSelectYear}
                    />
                  }
                  >
                    {downloadDataCheckObject.downloadDataStationYear ? (
                      downloadDataCheckObject.downloadDataStationYear.map(year => (
                        <MenuItem key={year} value={year} className="year-menu-item">
                          {year}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No data available</MenuItem>
                    )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={2} sm={6} xs={12}>
              <FormControl variant={strings.txtOutlined} fullWidth={true}>
                <InputLabel htmlFor={strings.idSelectMonth}>{strings.lblMonth}</InputLabel>
                <Select
                  value={selectedMonth}
                  onChange={this.handleSelectMonth}
                  input={
                    <OutlinedInput
                      labelWidth={50}
                      name={strings.lblMonth}
                      id={strings.idSelectMonth}
                    />
                  }
                  disabled={!selectedYear} // Disable when the year is not selected
                >
                  {downloadDataCheckObject.downloadDataStationMonth ? (
                    downloadDataCheckObject.downloadDataStationMonth.map(month => (
                      <MenuItem key={month} value={month} className="month-menu-item">
                        {getMonthName(month)}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No data available</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>

            </Grid>
          </Grid>
          <br />
          <div className='ReportButtonDiv'>
            {/*  Submit button */}
            <Button
              variant={strings.btnRaised}
              color={strings.colorPrimary}
              onClick={this.handleDownloadDataSubmit}
              disabled={
                !selectedYear 
              }
            >
              {strings.lblSubmit}
            </Button>
            <Button
                variant={strings.btnRaised}
                color={strings.colorPrimary}
                onClick={this.handleReset}
                disabled={this.state.isResetButtonDisabled}
              >
                {strings.lblReset}
            </Button>
          </div>
        </Page>
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  selectedStationName: downloadDataReducers.getSelectedStationName(state),
  currentStationName: downloadDataReducers.getCurrentDownloadDataStation(state),
  downloadDataCheckObject: downloadDataReducers.getDownloadDataCheck(state),
  selectedMonth: downloadDataReducers.getSelectedMonth(state),
  selectedYear: downloadDataReducers.getSelectedYear(state),

});

const mapActionsToProps = {
  setSelectDownloadDataStation: downloadDataActionMgr.setSelectDownloadDataStation,
  setCurrentDownloadDataStation: downloadDataActionMgr.setCurrentDownloadDataStation,

  resetSelectDownloadDataStation: downloadDataActionMgr.resetSelectDownloadDataStation,
  checkDownloadDataObject: downloadDataActionMgr.callCheckDownloadDataObjectApi,
  listDownloadDataObject: downloadDataActionMgr.callListDownloadDataObjectApi, 
  clearSelectedFiles: downloadDataActionMgr.clearSelectedFiles,
  selectYear: downloadDataActionMgr.setSelectDownloadDataYear,
  selectMonth: downloadDataActionMgr.setSelectDownloadDataMonth,
};

export default connect(mapStateToProps, mapActionsToProps)(
  (DownloadDataSelect)
 );